import { Eq } from "fp-ts/es6/Eq";
import { compareAttributes, VariantAttribute } from "@swo/shared";
import { array } from "fp-ts";

export const attributeEq: Eq<VariantAttribute> = {
  equals: (x, y) => compareAttributes(x, y),
};

export const attributeArrayUniq = array.uniq(attributeEq);
